import {
  selectPickedViewIds,
  setPickedViewIdAndPersist,
  setPickedViewIdsAndPersist,
  setShareId,
  useAppDispatch,
  useAppSelector,
} from '../../..'

export const usePickView = (): { pickView: (id: string, shareId?: string) => void } => {
  const pickedViewIds = useAppSelector(selectPickedViewIds)
  const dispatch = useAppDispatch()

  return {
    pickView: (id: string, shareId?: string): void => {
      if (!pickedViewIds.includes(id)) {
        dispatch(setPickedViewIdsAndPersist([...pickedViewIds, id]))
      }
      dispatch(setShareId(shareId))
      // shareId URL クエリパラメータは初期レンダリングのタブでのみ適用したいため、他のタブを選択したときにはクリアする
      const url = new URL(globalThis.location.href)
      url.searchParams.delete('shareId')
      globalThis.history.replaceState({}, '', url.toString())
      dispatch(setPickedViewIdAndPersist(id))
    },
  }
}
